import { WebPlugin } from '@capacitor/core';
export class rtsp_viewWeb extends WebPlugin {
    async startPull(options) {
        console.log('startPull', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async stopPull() {
        console.log('stopPull');
        throw this.unimplemented('Not implemented on web.');
    }
    async saveJpg(options) {
        console.log('saveJpg', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async saveMp4(options) {
        console.log('saveMp4', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async stopRecordMp4() {
        console.log('stopRecordMp4');
        throw this.unimplemented('Not implemented on web.');
    }
    async isRecording() {
        console.log('isRecording');
        throw this.unimplemented('Not implemented on web.');
    }
    async writeBinaryByJava(options) {
        console.log('writeBinaryByJava', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async startCameraPreview(options) {
        console.log('startCameraPreview', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async stopCameraPreview() {
        console.log('stopCameraPreview');
        throw this.unimplemented('Not implemented on web.');
    }
    async rtspUpdatePos(options) {
        console.log('rtspUpdatePos', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async rtspCreateDir(options) {
        console.log('string', options);
        throw this.unimplemented('Not implemented on web.');
    }
}
export class rtsp_jniWeb extends WebPlugin {
    constructor() {
        super();
        if (!rtsp_jniWeb.instance) {
            rtsp_jniWeb.instance = new rtsp_viewWeb();
        }
    }
    async startPull(options) {
        console.log('转发调用到rtsp_viewWeb.startPull');
        return rtsp_jniWeb.instance.startPull(options);
    }
    async stopPull() {
        console.log('转发调用到rtsp_viewWeb.stopPull');
        return rtsp_jniWeb.instance.stopPull();
    }
    async saveJpg(options) {
        console.log('转发调用到rtsp_viewWeb.saveJpg');
        return rtsp_jniWeb.instance.saveJpg(options);
    }
    async saveMp4(options) {
        console.log('转发调用到rtsp_viewWeb.saveMp4');
        return rtsp_jniWeb.instance.saveMp4(options);
    }
    async stopRecordMp4() {
        console.log('转发调用到rtsp_viewWeb.stopRecordMp4');
        return rtsp_jniWeb.instance.stopRecordMp4();
    }
    async isRecording() {
        console.log('转发调用到rtsp_viewWeb.isRecording');
        return rtsp_jniWeb.instance.isRecording();
    }
}
//# sourceMappingURL=web.js.map